import { QueryKey, useQuery } from '@tanstack/react-query';
import { useCurrentClientManager } from '@cko/dashboard-shared';

import { API_PATHS } from '../../environment/apiPaths';
import { useGetIntelligentAcceptanceAvailabilityFetcher } from './useGetIntelligentAcceptanceAvailabilityFetcher';
interface UseGetIntelligentAcceptanceAvailabilityOptions {
  enabled?: boolean;
}

const API_PATH = `${API_PATHS.prismInsightsApiBasePath}/client/status`;

export const useGetIntelligentAcceptanceAvailability = (
  options?: UseGetIntelligentAcceptanceAvailabilityOptions,
) => {
  const { enabled } = options || {};
  const { client } = useCurrentClientManager();
  const fetcher = useGetIntelligentAcceptanceAvailabilityFetcher();

  const queryKey: QueryKey = [API_PATH, { clientId: client?.id }];

  const {
    isLoading: isIntelligentAcceptanceLoading,
    isError: isIntelligentAcceptanceError,
    data: areIntelligentAcceptanceLinksAvailable,
  } = useQuery<boolean>(queryKey, fetcher, {
    enabled: Boolean(client?.id) && enabled,
    cacheTime: 60 * 60 * 1000, // 1 hour cache
  });

  const isLoading = isIntelligentAcceptanceLoading && enabled;
  const isError = isIntelligentAcceptanceError;

  return {
    areIntelligentAcceptanceLinksAvailable,
    isError,
    isLoading,
  };
};
